































import { Component, Vue, Inject, Prop, Emit, Watch } from 'vue-property-decorator'
import AbpBase from '../../../lib/abpbase'
@Component({})
export default class SidebarMenu extends AbpBase {
    name:string='sidebarMenu';
    @Prop({type:Array}) menuList:Array<any>;
    @Prop({type:Number}) iconSize:number;
    @Prop({type:String,default:'dark'}) menuTheme:string;
    @Prop({type:Array}) openNames:Array<string>;
    // itemTitle(item:any):string{
    //     return this.L(item.meta.title);
    // }
    @Emit('on-change')
    changeMenu(active:string){
        
    }
    updated () {
        this.$nextTick(() => {
            if (this.$refs.sideMenu) {
                (this.$refs.sideMenu as any).updateActiveName();
            }
        });
    }
    get user() {
        return this.$store.state.session.user
    }
    get menu() {
        return this.$store.state.app['menuList']
    }
    get flowTodoTotal() {
      let todoCount = this.$store.state.todoCount
      let total = todoCount.fileCount + todoCount.projectCount + todoCount.depositCount
      //  保密办审核
      if(this.$store.getters["session/hasRoles"]("保密办")) {
        total += todoCount.secretCount
      }
      // 提成系统
      let menu = this.menu.filter((item:any) => {return item.name == 'commission'})
      if (menu.length > 0) {
        total += todoCount.QRCount + todoCount.FQCount + todoCount.FPCount + todoCount.ZJQRCount + todoCount.ZXQRCount
      }
      return total
    }
}
